import React, { useState } from "react";
import { FormGroup, Notification, Tag, Button, Icon } from "xsolla-uikit";
import { gkPlatforms } from '../../data';
import CardNew from "./../PAcardNew";
import { PAgcGKprices } from './PAgcGKprices';
import PAh2 from './../PAh2';







export function PAgcGKplatforms({data}) {



  // const handlePlatform = (index, what, value = "invert") => {
  //   let platf = [...data.keyData.platforms]; // make a separate copy of the array
  //   let onePlatform = platf[index];
  //   onePlatform[what] = value === "invert" ? !onePlatform[what] : value;
  //   if (!onePlatform["added"]) {
  //     onePlatform["uploaded"] = false;
  //     onePlatform["enabled"] = false;
  //   }
  //   // this.updateStatus(true, platf);
  // };

  function checkIfHas(nw){
    let where = platf.indexOf(nw);
    return (where !== -1) ? where : false;
  }

  const handlePlatforms= (nw)=>{
    let newP = [...platf];
    let where = newP.indexOf(nw);

    if (where !== -1) {
      newP.splice(where,1)
    } else {
      newP = [...newP, nw]
    }
    setPlatf([...newP])
  }


  const [platf, setPlatf] = useState([])


  return (
    <div>

      <PlatformSelect
        // label="Select platforms"
        // platforms={
        //   data.keyData.platforms
        // }
        handlePlatform={handlePlatforms}
        showSelected={true}
        checkIfHas = {(nw)=>{
          debugger
          return checkIfHas(nw)
        }}
        platformsAdded={platf}
      />



      <FormGroup
        label={
          data.keyData.delivery
            .value === "self"
            ? "Customer can select from these options:"
            : null
        }
      >
        {!platf.length && (
          <div className="xsui-form-group--indentation-lg">
            <Notification
              title="Choose at least one platform"
              status="info"
            />
          </div>
        )}

        {!!platf.length && (
          platf.map((onePlatfname, i)=>{
            let onePlatform = gkPlatforms[onePlatfname];
            if (onePlatform) {return (renderLine(i, onePlatform, handlePlatforms))} else {
              return onePlatfname;
          }
        })
      )}

      </FormGroup>





    </div>
  )
}




const PlatformSelect = ({
  label = "",
  handlePlatform = () => {
    void 0;
  },
  platformsAdded = [],
  showSelected = false
}) => {

  function checkIfHas(nw){
    let where = platformsAdded.indexOf(nw);
    // debugger;
    return where;
  }

  return (
    <FormGroup label={label}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap"
        }}
      >
        {!!Object.keys(gkPlatforms).length &&
          Object.keys(gkPlatforms).map((onePlatformId, i) => {
            let onePlatform = gkPlatforms[onePlatformId];
            if (checkIfHas(onePlatform.id) === -1) {
              return (
                <div
                  key={`platform_${i}`}
                  style={{
                    marginBottom: "8px",
                    marginRight: "8px",
                    flexGrow: 0
                  }}
                >
                  <Tag
                    key={`${i}_${onePlatform.name}`}
                    selected={onePlatform.added}
                    value={onePlatform.name}
                    appearance="primary"
                    onClick={e => {
                      handlePlatform(onePlatform.id);
                    }}
                  >
                    <div
                      style={{
                        display: "flex"
                      }}
                    >
                      <div className="xsui-tag__label">{onePlatform.name}</div>
                    </div>
                  </Tag>
                </div>
              );
            }
          })}
      </div>
    </FormGroup>
  );
};


function renderLine(i, onePlatform, handlePlatform=()=>void(0)) {
  return <FormGroup indentation="md">
    <CardNew indentation="md" wave={false}>
    <FormGroup indentation="lg">
    {/* <div style={{display: 'flex', justifyContent: 'space-between'}}> */}
      <PAh2 tag="h4" title ={onePlatform.name}>
          <Icon size={22} name="delete" onClick={()=>{
            handlePlatform(onePlatform.id)
          }}/>
      </PAh2>
    {/* </div> */}
    <CardNew wave={false}>
      <FormGroup indentation="sm">
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <Button appearance="flatten">Upload keys</Button>

        </div>
      </FormGroup>
    </CardNew>
    </FormGroup>

    <FormGroup
      indentation="lg"
      >
        <PAgcGKprices platform={onePlatform.id}/>
    </FormGroup>

  </CardNew></FormGroup>;
}

